import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { DispatchInfoDialogData, DispatchType, FeedStockLoadScheduleDispatchDataResponse } from '../../../interfaces/feedstocklistmodel';
import { FeedstockService } from '../../../services/feedstockservice';
import { FeedStockLoadDispatchRequest, FeedStockLoadDispatchRequestCommand } from '../../../interfaces/pricematrixmodel';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-dispatch-info',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    DragDropModule
  ],
  templateUrl: './dispatch-info.component.html',
  styleUrls: ['./dispatch-info.component.scss']
})
export class DispatchInfoComponent implements OnInit {

  @ViewChild('dispatchForm') dispatchForm!: NgForm;

  fsLoadScheduleId: number;
  isAd: boolean;
  dataSource = new MatTableDataSource<FeedStockLoadScheduleDispatchDataResponse>([]);
  displayedColumns: string[] = ['type', 'email', 'phoneNumber'];
  dispatchTypeMapping: Record<DispatchType, number> = {
    [DispatchType.Customer]: 1,
    [DispatchType.Hauler]: 2,
    [DispatchType.DisposalSite]: 3
  };

  constructor(
    public dialogRef: MatDialogRef<DispatchInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DispatchInfoDialogData,
    private fsService: FeedstockService,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef
  ) {
    this.fsLoadScheduleId = data.fsLoadScheduleId;
    this.isAd = data.isAd;
  }

  ngOnInit(): void {
    this.loadDispatchDetails();
  }
  
  loadDispatchDetails(): void {
    this.fsService.getDispatchDetails(this.fsLoadScheduleId).subscribe({
      next: (data: FeedStockLoadScheduleDispatchDataResponse[]) => {
        let dispatches = data || [];
        
        const customerType = DispatchType.Customer;
        const haulerType = DispatchType.Hauler;
        const disposalSiteType = DispatchType.DisposalSite;

        if (!dispatches.some(d => d.type === customerType)) {
          dispatches.push(this.createDefaultDispatchEntry(customerType));
        }
        if (!dispatches.some(d => d.type === haulerType)) {
          dispatches.push(this.createDefaultDispatchEntry(haulerType));
        }
        
        console.log('Dispatch Details Loaded:', dispatches);
        this.dataSource.data = dispatches.sort((a, b) => {
          const order = [customerType, haulerType, disposalSiteType];
          return order.indexOf(a.type as DispatchType) - order.indexOf(b.type as DispatchType);
        });

        this.dataSource.data.forEach(d => {
          d.bcheckbox = (d.emailDispatched || d.smsDispatched) ? true : false;
        });

        console.log('Dispatch Details Loaded:', this.dataSource.data);
      }
    });
  }
  
  private createDefaultDispatchEntry(type: DispatchType): FeedStockLoadScheduleDispatchDataResponse {
    return {
      id: 0,
      fsLoadScheduleId: this.fsLoadScheduleId,
      type: type,
      selectedType: false,
      email: null,
      phoneNumber: null,
      emailDispatched: null,
      smsDispatched: null,
      ctype: null,
      bcheckbox: false
    };
  }
  
  onSave(): void {
    if (this.dispatchForm.invalid) {
      this.dispatchForm.form.markAllAsTouched();
      return;
    }
    const dispatchRequests: FeedStockLoadDispatchRequest[] = this.dataSource.data
      //.filter(item => item.bcheckbox)
      .map(item => {
        var ctypeId = this.dispatchTypeMapping[item.type as DispatchType] || 0;
        const request: FeedStockLoadDispatchRequest = {
          type: item.type,
          fsLoadScheduleId: item.fsLoadScheduleId,
          email: item.email && item.email.trim() !== '' ? item.email.trim() : null,
          phoneNumber: item.phoneNumber && item.phoneNumber.trim() !== '' ? item.phoneNumber.trim() : null,
          emailDispatched: item.bcheckbox,
          smsDispatched: item.bcheckbox,
          ctype: ctypeId
        };
        return request;
      });

    if (dispatchRequests.length === 0) {
      this.dialogRef.close(false);
      return;
    }
    const payload: FeedStockLoadDispatchRequestCommand = {
      dispatchData: dispatchRequests,
      feedStockLoadScheduleId: this.fsLoadScheduleId
    };
    console.log("displatch save", payload);
    this.fsService.saveDispatchDetails(payload).subscribe({
      next: (response) => {
        this.dialogRef.close(true);        
      }
    });
  }

  formatPhoneNumber(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    let formattedValue = '';
    if (value.length > 0) {
      formattedValue = '(' + value.substring(0, 3);
    }
    if (value.length >= 4) {
      formattedValue += ') ' + value.substring(3, 6);
    }
    if (value.length >= 7) {
      formattedValue += '-' + value.substring(6, 10);
    }
    input.value = formattedValue;
    this.dispatchForm.controls[controlName].setValue(formattedValue, { emitEvent: false });
  }
  
  onEmailChange(row: FeedStockLoadScheduleDispatchDataResponse, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value && row.phoneNumber) {
      row.phoneNumber = null;
    }
    
    if (inputElement.value) {
      row.selectedType = true;
    }
  }
  
  onPhoneChange(row: FeedStockLoadScheduleDispatchDataResponse, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value && row.email) {
      row.email = null;
    }
    
    if (inputElement.value) {
      row.selectedType = true;
    }
  }
  
  onSelectedTypeChange(row: FeedStockLoadScheduleDispatchDataResponse, isChecked: boolean): void {
    if (!isChecked) {
      row.email = null;
      row.phoneNumber = null;
    }
  }
  
  isRowValid(row: FeedStockLoadScheduleDispatchDataResponse): boolean {
    if (row.selectedType) {
      const emailValid = !!(row.email && this.isValidEmail(row.email));
      const phoneValid = !!(row.phoneNumber && this.isValidPhoneNumber(row.phoneNumber));
      return emailValid || phoneValid;
    }
    return true;
  }
  
  isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
  }
  
  isValidPhoneNumber(phone: string): boolean {
    const digits = phone.replace(/\D/g, '');
    return digits.length === 10;
  }
  
  trackByDispatchId(index: number, item: FeedStockLoadScheduleDispatchDataResponse): number {
    return item.id || index;
  }
  
  onClose(): void {
    this.dialogRef.close(false);
  }
}